export default "<div id=\"our-instruments-page\" class=\"page container\">\n    <h1>Our Instruments</h1>\n</div>\n";